export { default as StandardReviewsPage } from './StandardReviewsPage';
